export const enum ApiErrors {
  ALREADY_VALID = "ALREADY_VALID",
  ANON_ID_EXPIRED = "ANON_ID_EXPIRED",
  ANON_ID_INACTIVE = "ANON_ID_INACTIVE",
  ANON_ID_NOT_FOUND = "ANON_ID_NOT_FOUND",
  DOC_NOT_FOUND = "DOC_NOT_FOUND",
  DOC_TYPE_NOT_FOUND = "DOC_TYPE_NOT_FOUND",
  LOGGED_OUT = "LOGGED_OUT",
  NO_ATTEMPTS_REMAINING = "NO_ATTEMPTS_REMAINING",
  MISMATCHED_CONTENT_TYPE = "MISMATCHED_CONTENT_TYPE"
}



// WEBPACK FOOTER //
// ./src/constants/Errors.ts